import React, {useEffect, useState} from 'react';
import {Button, Layout, theme} from 'antd';
import SiderMenu from "../menu/sider.menu";
import HeaderMenu from "../menu/header.menu";
import {Outlet} from "react-router-dom";
import InactivityUtil from "../util/inactivity.util";
import {ResponseMessageUtil} from "../util/responseMessage.util";
import {EventProvider} from "../../provider/event/event.context.provider";
import styled from "styled-components";
import {ProcessLoader} from "../processLoader";
import {MenuOutlined} from '@ant-design/icons';
import ScrollToTop from "../page/scrollToTop";
import ErrorBoundary from "./errorBoundary.wrapper";

const { Header, Content} = Layout;

const StyledContent = styled(Content)`
    margin: 72px 16px 16px 16px;
    padding-bottom: 40px;

    &.menu-visible {
        margin: 72px 16px 16px 258px;
    }

    .ant-form-item {
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    }
    
    .ant-btn-primary {
        &:hover, &:focus {
            background-color: #9ab108;
            border-color: #9ab108;
        }
    }

    .ant-input[disabled] {
        color: #333;
    }
    
    .ant-btn-secondary {
        background-color: #ffa200;
        border-color: #ffa200;
        color: white;
        
        &:hover, &:focus {
            background-color: #e59100!important;
            border-color: #e59100!important;
            color: white!important;
        }
    }

    @media (min-width: 1600px) {
        .ant-form-vertical {
            .ant-form-item-row {
                flex-direction: row;
            }
            .ant-form-item {
                .ant-form-item-control {
                    width: unset;
                }
            }
        }
    }

    @media (max-width: 1600px) {
        .ant-form-vertical {
            .ant-form-item-row {
                [class^="ant-col-"], [class*=" ant-col-"] {
                    width: 100%;
                    max-width: 100%;
                }
            }
        }
    }
`;

const StyledLayout = styled(Layout)`
    @media (max-width: 992px) {
        .wrapped-content {
            margin-left: 16px!important;
        }
        .wrapped-buttons { 
            left: 0!important;   
        }
    }
    @media (min-width: 992px) {
        .menu {
            display: none;
        }
    }
`;

const Container: React.FC = () => {
    const {
        token: { colorBgContainer },
    } = theme.useToken();

    const [menuVisible, setMenuVisible] = useState<boolean>(true);

    useEffect(() => {
        const handleResize = () => {
            const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
            setMenuVisible(viewportWidth > 992);
        };

        handleResize();

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return (
        <StyledLayout style={{ minHeight: '100vh', background: "#e5e5e5" }}>
            <ScrollToTop />
            <SiderMenu visible={menuVisible} />
            <Layout style={{ position: "relative", background: "#e5e5e5" }}>
                <Header style={{
                    padding: 0,
                    background: colorBgContainer,
                    position: 'fixed',
                    zIndex: 1,
                    width: '100%',
                }}>
                    <Button
                        className="menu"
                        type="primary"
                        icon={<MenuOutlined />}
                        style={{ marginLeft: '16px' }}
                        onClick={() => setMenuVisible(!menuVisible)}
                    />
                    <HeaderMenu />
                    <ProcessLoader />
                </Header>
                <StyledContent className={`${menuVisible? "menu-visible":""} wrapped-content`} >
                    {/*<BreadcrumbUtil />*/}
                    <ResponseMessageUtil />
                    <ErrorBoundary>
                        <EventProvider>
                            <Outlet/>
                        </EventProvider>
                    </ErrorBoundary>
                    <InactivityUtil />
                </StyledContent>
            </Layout>
        </StyledLayout>
    );
}

export default Container;